export default "__VITE_ASSET__nzXLWTeh__"